module.exports = "data:image/png;base64,ZXhwb3J0IGRlZmF1bHQgX193ZWJwYWNrX3B1YmxpY19wYXRoX18gKyAiZDVkYTU0MDI3MWIxNzA3MDBhZGI2MTYyYTE3NGI4MTcucG5nIjs="